export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-img5-f4c8af7002051a30f8a8b8063e1d856d.png";